import Swal from "sweetalert2";
import "./gameAlert.css";

function escapeHtml(str) {
  return String(str ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

const ICON_GLYPH = {
  success: "✓",
  error: "!",
  info: "i",
};

/**
 * Themed SweetAlert for game stages — navy / sky blues from stage backgrounds.
 */
export function fireGameAlert({
  icon = "info",
  title = "",
  text = "",
  confirmButtonText = "OK",
  allowOutsideClick = true,
  allowEscapeKey = true,
  /** Ignore accidental outside/key closes for this many ms after open. */
  dismissGuardMs = 0,
} = {}) {
  const kind = ICON_GLYPH[icon] ? icon : "info";
  const glyph = ICON_GLYPH[kind];
  const titleHtml = title
    ? `<h2 class="game-alert__title">${escapeHtml(title)}</h2>`
    : "";
  const textHtml = text
    ? `<p class="game-alert__text">${escapeHtml(text)}</p>`
    : `<p class="game-alert__text"></p>`;

  const guardMs = Math.max(0, Number(dismissGuardMs) || 0);
  let guardUntil = 0;

  return Swal.fire({
    html: `<div class="game-alert game-alert--${kind}">
      <div class="game-alert__badge" aria-hidden="true">${glyph}</div>
      ${titleHtml}
      ${textHtml}
      <button type="button" class="game-alert__btn" data-game-alert-close disabled>${escapeHtml(
        confirmButtonText
      )}</button>
    </div>`,
    showConfirmButton: false,
    showCloseButton: false,
    allowOutsideClick: () => {
      if (!allowOutsideClick) return false;
      return Date.now() >= guardUntil;
    },
    allowEscapeKey: () => {
      if (!allowEscapeKey) return false;
      return Date.now() >= guardUntil;
    },
    width: "min(92vw, 26em)",
    heightAuto: true,
    scrollbarPadding: false,
    returnFocus: false,
    customClass: {
      popup: "game-alert-popup",
      htmlContainer: "game-alert-popup__html",
      container: "game-alert-container",
    },
    didOpen: () => {
      guardUntil = Date.now() + guardMs;
      const btn = Swal.getPopup()?.querySelector("[data-game-alert-close]");
      if (!btn) return;

      const enableClose = () => {
        btn.disabled = false;
        btn.addEventListener("click", () => Swal.close(), { once: true });
      };

      if (guardMs > 0) {
        window.setTimeout(enableClose, guardMs);
      } else {
        enableClose();
      }
    },
  });
}
